import React, { Component } from 'react';
import { Container, Col, Row, Badge } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux'

import { selectAllUsersData } from './redux/currentUserSlice';

class CalendarItem extends Component {

	constructor(props) {
		super(props);
		this.todayItemRef = React.createRef();
	}

	setActiveItemElement() {
		this.todayItemRef.current.click();
	}

	render() {

		const { date, view, activeStartDate } = this.props;
		const dateNow = new Date();

		let calendarItem;

		if (this.props.notificationsData.length > 0) {
			calendarItem = this.props.notificationsData.find(x => { return new Date(x.EventDate).getTime() == date.getTime() });
		}

		const EventNotifiedCount = calendarItem ? calendarItem.EventNotifiedCount : 0;
		const EventAcceptedCount = calendarItem ? calendarItem.EventAcceptedCount : 0;
		const EventEditedCount = calendarItem ? calendarItem.EventEditedCount : 0;
		const EventRejectedCount = calendarItem ? calendarItem.EventRejectedCount : 0;

		return (
			<Container ref={this.todayItemRef} className="m-0 p-0 ">
				<Row className="m-0 mb-1 me-1 ">
					<Col className={"m-0 p-0 p-101 border rounded " + (dateNow.setHours(0, 0, 0, 0) == date.setHours(0, 0, 0, 0) ? " border-primary " : "")} >
						<div className="d-flex flex-column p-0 m-0 rounded calendarItemContainer">
							<div className="d-flex flex-shrink-1 flex-col mb-4 position-relative">
								<div className="d-flex text-start m-0 ps-2 pt-1  calendar-day-number-font " >{date.getDate()}</div>
							</div>
							<div className="text-end m-1">
								<Badge className={"notification-notified position-relative ms-1" + (EventNotifiedCount == 0 ? " invisible" : "")}>
									<div className="position-absolute top-50 start-50 translate-middle">
										{EventNotifiedCount}
									</div>
									<div className="invisible">0</div>
								</Badge>
								<Badge className={"notification-accepted position-relative ms-1" + (EventAcceptedCount == 0 ? " d-none" : "")} >
									<div className="position-absolute top-50 start-50 translate-middle">
										{EventAcceptedCount}
									</div>
									<div className="invisible">0</div>
								</Badge>
								<Badge className={"notification-edited position-relative ms-1" + (EventEditedCount == 0 ? " d-none" : "")}>
									<div className="position-absolute top-50 start-50 translate-middle">
										{EventEditedCount}
									</div>
									<div className="invisible">0</div>
								</Badge>
								<Badge className={"notification-rejected position-relative ms-1" + (EventRejectedCount == 0 ? " d-none" : "")}>
									<div className="position-absolute top-50 start-50 translate-middle">
										{EventRejectedCount}
									</div>
									<div className="invisible">0</div>
								</Badge>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
		);
	}
}



function withMyHook(Component) {



	return function WrappedComponent(props) {

		/*const getUserById = (userId) => {
			return useSelector((state) =>
				state.users ? state.users.find((user) => user.id === userId) : null
			);
		};

		const user = getUserById(14349);

		*/

		const notificationsData = useSelector((state) => state.notification.notificationsData);

		

		return <Component {...props} ref={props.refObj} notificationsData={notificationsData} />;
	}
}

export default withMyHook(CalendarItem)
